export default __webpack_public_path__ + "images/au-932d918261bcbb88f0cc22baa8e5f32f.svg";